import React, { useState, useEffect } from 'react';
import './Login.css';
import { TermsAndConditions, PrivacyPolicy } from './components/legal';

function Login({ onLogin }) {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    password: '',
    edad: '',
    genero: '',
    pais: ''
  });
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [forgotPassword, setForgotPassword] = useState(false);
  const [resetStep, setResetStep] = useState(1);
  const [resetEmail, setResetEmail] = useState('');
  const [resetCode, setResetCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const paises = [
    { code: 'ar', name: '🇦🇷 Argentina' },
    { code: 'bo', name: '🇧🇴 Bolivia' },
    { code: 'br', name: '🇧🇷 Brasil' },
    { code: 'cl', name: '🇨🇱 Chile' },
    { code: 'co', name: '🇨🇴 Colombia' },
    { code: 'cr', name: '🇨🇷 Costa Rica' },
    { code: 'cu', name: '🇨🇺 Cuba' },
    { code: 'ec', name: '🇪🇨 Ecuador' },
    { code: 'sv', name: '🇸🇻 El Salvador' },
    { code: 'es', name: '🇪🇸 España' },
    { code: 'us', name: '🇺🇸 Estados Unidos' },
    { code: 'gt', name: '🇬🇹 Guatemala' },
    { code: 'hn', name: '🇭🇳 Honduras' },
    { code: 'mx', name: '🇲🇽 México' },
    { code: 'ni', name: '🇳🇮 Nicaragua' },
    { code: 'pa', name: '🇵🇦 Panamá' },
    { code: 'py', name: '🇵🇾 Paraguay' },
    { code: 'pe', name: '🇵🇪 Perú' },
    { code: 'pr', name: '🇵🇷 Puerto Rico' },
    { code: 'do', name: '🇩🇴 República Dominicana' },
    { code: 'uy', name: '🇺🇾 Uruguay' },
    { code: 've', name: '🇻🇪 Venezuela' },
    { code: 'kr', name: '🇰🇷 Corea del Sur' },
    { code: 'cn', name: '🇨🇳 China' },
    { code: 'jp', name: '🇯🇵 Japón' },
    { code: 'fr', name: '🇫🇷 Francia' },
    { code: 'de', name: '🇩🇪 Alemania' },
    { code: 'it', name: '🇮🇹 Italia' },
    { code: 'gb', name: '🇬🇧 Reino Unido' },
    { code: 'ca', name: '🇨🇦 Canadá' },
    { code: 'au', name: '🇦🇺 Australia' },
    { code: 'ru', name: '🇷🇺 Rusia' },
    { code: 'in', name: '🇮🇳 India' },
    { code: 'pt', name: '🇵🇹 Portugal' },
    { code: 'nl', name: '🇳🇱 Países Bajos' },
    { code: 'be', name: '🇧🇪 Bélgica' },
    { code: 'se', name: '🇸🇪 Suecia' },
    { code: 'no', name: '🇳🇴 Noruega' },
    { code: 'dk', name: '🇩🇰 Dinamarca' },
    { code: 'fi', name: '🇫🇮 Finlandia' },
    { code: 'pl', name: '🇵🇱 Polonia' },
    { code: 'tr', name: '🇹🇷 Turquía' },
    { code: 'gr', name: '🇬🇷 Grecia' },
    { code: 'at', name: '🇦🇹 Austria' },
    { code: 'ch', name: '🇨🇭 Suiza' },
    { code: 'ie', name: '🇮🇪 Irlanda' },
    { code: 'nz', name: '🇳🇿 Nueva Zelanda' },
    { code: 'za', name: '🇿🇦 Sudáfrica' },
    { code: 'eg', name: '🇪🇬 Egipto' },
    { code: 'ma', name: '🇲🇦 Marruecos' },
    { code: 'ng', name: '🇳🇬 Nigeria' },
    { code: 'ke', name: '🇰🇪 Kenia' },
    { code: 'th', name: '🇹🇭 Tailandia' },
    { code: 'vn', name: '🇻🇳 Vietnam' },
    { code: 'ph', name: '🇵🇭 Filipinas' },
    { code: 'id', name: '🇮🇩 Indonesia' },
    { code: 'my', name: '🇲🇾 Malasia' },
    { code: 'sg', name: '🇸🇬 Singapur' },
    { code: 'il', name: '🇮🇱 Israel' },
    { code: 'ae', name: '🇦🇪 Emiratos Árabes' },
    { code: 'sa', name: '🇸🇦 Arabia Saudita' }
  ];

  useEffect(() => {
    const particles = [];
    for (let i = 0; i < 10; i++) {
      particles.push(<div key={i} className="ash-particle"></div>);
    }
    return () => {};
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validar términos solo en registro
    if (!isLogin && !acceptedTerms) {
      setError('Debes aceptar los Términos y Condiciones para registrarte');
      return;
    }

    setLoading(true);

    try {
      const endpoint = isLogin ? '/api/auth/login' : '/api/auth/register';
      const body = isLogin 
        ? { email: formData.email, password: formData.password }
        : { ...formData, acceptedTerms: true };

      const response = await fetch(`${process.env.REACT_APP_API_URL}${endpoint.replace('/api', '')}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('userId', data.userId);
        localStorage.setItem('userName', data.nombre || formData.nombre);
        onLogin(data);
      } else {
        setError(data.error || 'Error en la autenticación');
      }
    } catch (err) {
      setError('Error de conexión. Verifica que el backend esté corriendo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      {[...Array(30)].map((_, i) => (
        <div key={i} className="ash-particle"></div>
      ))}
      
      <div className="login-box">
        <img src="/img/logo.png" alt="TKD Game" className="login-logo" />
        <h2>{isLogin ? 'Iniciar Sesión' : 'Registrarse'}</h2>

        <form onSubmit={handleSubmit}>
          {!isLogin && (
            <>
              <div className="form-row single">
                <input
                  type="text"
                  placeholder="Nombre"
                  value={formData.nombre}
                  onChange={(e) => setFormData({...formData, nombre: e.target.value})}
                  required
                />
              </div>
              <div className="form-row">
                <input
                  type="number"
                  placeholder="Edad"
                  value={formData.edad}
                  onChange={(e) => setFormData({...formData, edad: e.target.value})}
                  required
                  min="5"
                  max="120"
                />
                <select
                  value={formData.genero}
                  onChange={(e) => setFormData({...formData, genero: e.target.value})}
                  required
                >
                  <option value="">Género</option>
                  <option value="M">Masculino</option>
                  <option value="F">Femenino</option>
                </select>
              </div>
              <div className="form-row single">
                <select
                  value={formData.pais}
                  onChange={(e) => setFormData({...formData, pais: e.target.value})}
                  required
                  style={{ fontSize: '14px' }}
                >
                  <option value="">Selecciona tu país</option>
                  {paises.map(p => (
                    <option key={p.code} value={p.code}>{p.name}</option>
                  ))}
                </select>
              </div>
            </>
          )}
          
          <div className="form-row single">
            <input
              type="email"
              placeholder="Email"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              required
            />
          </div>
          
          <div className="form-row single">
            <input
              type="password"
              placeholder="Contraseña (mín. 6 caracteres)"
              value={formData.password}
              onChange={(e) => setFormData({...formData, password: e.target.value})}
              required
              minLength="6"
            />
          </div>

          {!isLogin && (
            <div className="terms-checkbox">
              <input
                type="checkbox"
                id="acceptTerms"
                checked={acceptedTerms}
                onChange={(e) => setAcceptedTerms(e.target.checked)}
              />
              <label htmlFor="acceptTerms">
                Acepto los{' '}
                <span className="legal-link" onClick={(e) => { e.preventDefault(); setShowTerms(true); }}>
                  Términos y Condiciones
                </span>
                {' '}y la{' '}
                <span className="legal-link" onClick={(e) => { e.preventDefault(); setShowPrivacy(true); }}>
                  Política de Privacidad
                </span>
              </label>
            </div>
          )}

          {error && <div className="error-message">{error}</div>}

          <button type="submit" disabled={loading || (!isLogin && !acceptedTerms)}>
            {loading ? 'Cargando...' : (isLogin ? 'ENTRAR' : 'REGISTRARSE')}
          </button>
        </form>

        {isLogin && !forgotPassword && (
          <p className="forgot-text">
            <span onClick={() => { setForgotPassword(true); setError(''); setSuccessMsg(''); setResetStep(1); }}>
              ¿Olvidaste tu contraseña?
            </span>
          </p>
        )}

        <p className="toggle-text">
          {isLogin ? '¿No tienes cuenta?' : '¿Ya tienes cuenta?'}
          <span onClick={() => {
            setIsLogin(!isLogin);
            setError('');
            setAcceptedTerms(false);
            setForgotPassword(false);
          }}>
            {isLogin ? ' Regístrate' : ' Inicia sesión'}
          </span>
        </p>
      </div>

      {showTerms && <TermsAndConditions onClose={() => setShowTerms(false)} />}
      {showPrivacy && <PrivacyPolicy onClose={() => setShowPrivacy(false)} />}

      {forgotPassword && (
        <div className="forgot-overlay" onClick={() => setForgotPassword(false)}>
          <div className="forgot-box" onClick={e => e.stopPropagation()}>
            <button className="forgot-close" onClick={() => setForgotPassword(false)}>✕</button>
            <h2>🔑 Recuperar Contraseña</h2>

            {resetStep === 1 && (
              <form onSubmit={async (e) => {
                e.preventDefault();
                setError(''); setLoading(true);
                try {
                  const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/forgot-password`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ email: resetEmail })
                  });
                  if (res.ok) {
                    setResetStep(2);
                    setSuccessMsg('Si el email existe, recibirás un código');
                  } else {
                    const data = await res.json();
                    setError(data.error || 'Error al enviar código');
                  }
                } catch { setError('Error de conexión'); }
                setLoading(false);
              }}>
                <p>Ingresá tu email y te enviaremos un código</p>
                <input type="email" placeholder="Tu email" value={resetEmail} onChange={e => setResetEmail(e.target.value)} required />
                {error && <div className="error-message">{error}</div>}
                <button type="submit" disabled={loading}>{loading ? 'Enviando...' : 'ENVIAR CÓDIGO'}</button>
              </form>
            )}

            {resetStep === 2 && (
              <form onSubmit={async (e) => {
                e.preventDefault();
                setError(''); setLoading(true);
                try {
                  const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/reset-password`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ email: resetEmail, code: resetCode, newPassword })
                  });
                  const data = await res.json();
                  if (res.ok) {
                    setResetStep(3);
                  } else {
                    setError(data.error || 'Código inválido');
                  }
                } catch { setError('Error de conexión'); }
                setLoading(false);
              }}>
                {successMsg && <div className="success-message">{successMsg}</div>}
                <input type="text" placeholder="Código de 6 dígitos" value={resetCode} onChange={e => setResetCode(e.target.value)} maxLength={6} required />
                <input type="password" placeholder="Nueva contraseña (mín. 6)" value={newPassword} onChange={e => setNewPassword(e.target.value)} minLength={6} required />
                {error && <div className="error-message">{error}</div>}
                <button type="submit" disabled={loading}>{loading ? 'Cambiando...' : 'CAMBIAR CONTRASEÑA'}</button>
              </form>
            )}

            {resetStep === 3 && (
              <div>
                <p className="success-message">✅ ¡Contraseña cambiada!</p>
                <button onClick={() => { setForgotPassword(false); setResetStep(1); setResetCode(''); setNewPassword(''); }}>INICIAR SESIÓN</button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Login;
